import { PageController } from '@client/components/_core/layout/PageController';
import { StaffLodgementFlow } from '@client/components/lodgement/staff/StaffLodgementFlow';
import { createFileRoute } from '@tanstack/react-router';
import { FilePlus } from 'lucide-react';

/**
 * Staff lodge a claim on a claimant's behalf through a products-v2 INTERNAL link, opened from the
 * claims list New claim menu (docs/plan/staff-lodgement-console/plan.md).
 */
export const Route = createFileRoute('/console/$orgId/claims/lodge/$linkId')({
    staticData: {
        metadata: { title: 'Lodge a claim' },
        breadcrumb: { title: 'Lodge a claim' },
        ui: {
            icon: FilePlus,
            title: 'Lodge a claim',
            subtitle: "Lodge a claim on a claimant's behalf",
        },
        modules: ['claim'],
        permissions: ['claim:create'],
        featureFlag: 'is-products-v2-enabled',
    },
    params: {
        parse({ linkId }) {
            return { linkId: BigInt(linkId) };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { linkId } = Route.useParams();
    return (
        <PageController route={Route}>
            <StaffLodgementFlow key={linkId.toString()} linkId={linkId} />
        </PageController>
    );
}
